export default __webpack_public_path__ + "static/media/games1.3cefa6b6.png";